import React, { useState, useEffect } from "react";
import "./SideNav.scss";
import { Col, Row, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import { useDb } from "../context/db";
import { useAuth } from "../context/Auth";

import {
  generateGravatar,
  GetDbObject,
  getRequestOptions,
} from "../../Utils/commonApi";

import { MdChevronLeft } from "react-icons/md";
import ChangeCompanyAndRole from "../Popouts/ChangeCompanyAndRole/ChangeCompanyAndRole";
import ResetComplianceForm from "../Popouts/ResetComplianceForm/ResetComplianceForm";
import VerticalNavigationBar from "../MSP/VerticalNavigationBar/VerticalNavigationBar";
import { FiPlusCircle } from "react-icons/fi";
import { IoMdBriefcase } from "react-icons/io";

import { getMenuCollapseStatus } from "../../redux/highgroundGlobalState/selectors";
import { createStructuredSelector } from "reselect";
import { menuToggle } from "../../redux/highgroundGlobalState/actions";
import { getUser } from "../../redux/userState/selectors";
import { setuser } from "../../redux/userState/actions";
import { useDispatch, useSelector } from "react-redux";
import { TrackUser } from "../../Utils/SegmentFunctions";
import { TrimString } from "../../Utils/StringTrimmer";
import useGetSBSidebarNav from "../../hooks/get-sb-sidebar-nav.hook";
import Loader from "../../Components/Common/loader";
import SplitSectionTabLoader from "../ActionCenter/SplitSectionTabLoader";
import { ROUTE_PATHS } from "../../constants/app.constants";
import useRespondTo from "../../hooks/respond-to.hook";
import { WindowBreakpoints } from "../../constants/window.constants";

function getNavigationElements() {
  const IMAGE_SIZE = 25;
  return [
    {
      text: "Add Client",
      image: <FiPlusCircle size={IMAGE_SIZE} />,
      url: "/MSP/Clients/Add",
    },
    {
      text: "Clients",
      image: <IoMdBriefcase size={IMAGE_SIZE} />,
      url: "/MSP/Clients",
    },
  ];
}

const CollapseButton = ({ isMenuCollapse, handleCollapse }) => {
  return (
    <div
      className="px-0 my-auto cursor-pointer pointer"
      onClick={(e) => {
        e.stopPropagation();
        handleCollapse();
      }}
    >
      {isMenuCollapse ? (
        <img
          alt=""
          src={"/images/dashboard/sideNavDoubleArrrow.svg"}
        />
      ) : (
        <img
          alt=""
          style={{ width: "10px" }}
          src={"/images/dashboard/MenuCollapse.svg"}
        />
      )}
    </div>
  );
}

const SideNav = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isTablet = useRespondTo(WindowBreakpoints.lg);
  const isMenuCollapse = useSelector((state) => state.global.menuCollapse) || isTablet;
  const userDetails = useSelector((state) => state.user?.userDetail);
  const URLpath = window.location.pathname.split("/");
  const showRequestDemo = useSelector(
    (state) => state?.user?.userDetail?.AccessObjList?.[2]?.Option
  );
  const upgradePopupData = useSelector(
    (state) =>
      state?.user?.userDetail?.AccessObjList?.filter(
        (item) => item?.Question === "Request Demo Visibility"
      )?.[0]?.UpgradeOptions
  );
  const { data: navData, isLoading: isNavLoading, getSidebarNav } = useGetSBSidebarNav();
  //States
  const [modal, setModal] = useState(false);
  const { userType, authTokens } = useAuth();
  // const dbObj = dummy

  const { 
    dbObj,
     setdbObject, impersinatingDetails, setImpersinatingDetails } =
    useDb();
  const userStringType = determineUserRole(userType);
  const userStringActualType = determineUserRole(userType, false);
  const [userGravatarBool, setUserGravatarBool] = useState(false);
  // const [isMenuCollapse, setIsMenuCollapse] = useState(false);
  const [isUpgradeProCollapse, setIsUpgradeProCollapse] = useState(true);
  const selectedUrl = JSON.parse(localStorage.getItem("currentUrl"));
  const MspUser = localStorage.getItem("msp");
  const NAVIGATION_BUTTONS = getNavigationElements();
  if (selectedUrl == null) {
    localStorage.setItem(
      "currentUrl",
      JSON.stringify({ url: `/${userStringType}/dashboard`, name: "Dashboard" })
    );
  }

  useEffect(() => {
    getSidebarNav();
  }, []);

  useEffect(() => {
    if (dbObj && dbObj.UserDetail)
      generateGravatar(dbObj.UserDetail.Avatar).then((value) =>
        setUserGravatarBool(value ? value : "404")
      );
    else if (userType == 444444 && impersinatingDetails) {
      initaliseDbObject();
    }
  }, [dbObj]);
  const CURRENT_URL = useLocation().pathname;
  //Constants
  const USER_COMPANY =
    dbObj != undefined && dbObj.UserDetail != undefined
      ? dbObj.UserDetail.OrgName
      : "";
  const USER_ROLE =
    dbObj != undefined && dbObj.UserDetail != undefined
      ? dbObj.UserDetail.Role
      : "";

  function determineUserRole(role, impersinationFlag = true) {
    role = role?.toString();
    switch (role) {
      case "111111":
        return "ceo";
      case "999999":
        return "ceo";
      case "333333":
        return "cfo";
      case "222222":
        return "cto";
      case "ceo":
        return "111111";
      case "cfo":
        return "333333";
      case "cto":
        return "222222";
      default:
        return "ceo";
    }
    if (
      impersinationFlag &&
      role == "444444" &&
      impersinatingDetails &&
      impersinatingDetails.role
    ) {
      return determineUserRole(impersinatingDetails.role.toString());
    }
    return "MSP";
  }

  

  async function initaliseDbObject() {
    console.log("impersinatingDetails", impersinatingDetails.role);
    var dbContext = await GetDbObject(authTokens, impersinatingDetails.role);
    console.log("DB Context", dbContext);
    setdbObject(dbContext);
  }

  const handleCollapse = () => {
    // const elmt = document.getElementById("mainRow");
    // elmt.classList.toggle("smallSideMenu");
    // elmt.classList.toggle("largeSideMenu");
    dispatch(menuToggle(!isMenuCollapse));
  };

  const upgradeProHandler = (event) => {
    setIsUpgradeProCollapse(true);
  };

  async function loginAs(userEvent) {
    var user = userEvent.target.innerText.toLowerCase();

    var newImpersinatingDetails = Object.assign({}, impersinatingDetails);
    newImpersinatingDetails.role = determineUserRole(user);

    setdbObject();
    setImpersinatingDetails(newImpersinatingDetails);

    window.location.replace(`/${user}/dashboard`);
  }

  async function updateuser(role) {
    let olduser = window.localStorage.getItem("recentUser");
    olduser = JSON.parse(olduser);
    const data = await fetch(
      `${
        process.env.REACT_APP_API_BASE_URL
      }/CC_API/GetDemoOrgAndRoleAccessToken?orgId=${
        olduser.UserDetail.OrgId
      }&roleId=${111111}`,
      getRequestOptions(authTokens)
    ).then((response) => response.json());
    if (data.AccessToken) {
      window.localStorage.clear();
      window.localStorage.setItem("tokens", `"${data.AccessToken}"`);
      window.localStorage.setItem("userType", data.mr.EntityId);
      window.localStorage.setItem("userAuthenticated", true);
      window.localStorage.setItem("activeCompany", olduser.UserDetail.OrgId);
      window.localStorage.setItem("user_MessageObj", `"${data.mr.Message}"`);
      window.localStorage.setItem("object_Data", JSON.stringify(olduser));
      localStorage.setItem("msp", false);
      window.location.replace("/MSP/Clients");
    }
    return false;
  }
 

  const SideBarData = {
    8955826: {
      fullName: "Overview",
      collapsedName: "Over..",
      url: ROUTE_PATHS.subscriptionPortalPages.overview,
      lockIcon: "/images/msp/lock-icon.svg",
      menuIcon: "/images/navIcons/dashboardIcon.svg",
      selectedUrl: "overview",
    },
    8955827: {
      fullName: "Attack Surface",
      collapsedName: "Attack..",
      url: ROUTE_PATHS.subscriptionPortalPages.mspAccounts, 
      lockIcon: "/images/msp/lock-icon.svg",
      menuIcon: "/images/attack-surface/attack_surface_dashboard_icon.svg",
      selectedUrl: "msp-accounts",
    },

    8955828: {
      fullName: "Cyber Trend Data",
      collapsedName: "Cyber..",
      url: ROUTE_PATHS.subscriptionPortalPages.saasAccounts,
      lockIcon: "/images/msp/lock-icon.svg",
      menuIcon: "/images/navIcons/cyberTrendDashboardIcon.svg",
      selectedUrl: "saas-accounts",
    },
    8955829: {
      fullName: "Technical Drilldown",
      collapsedName: "Technical..",
      url: ROUTE_PATHS.subscriptionPortalPages.finance,
      lockIcon: "/images/msp/lock-icon.svg",
      menuIcon: "/images/navIcons/technicalDrillDownDashboardIcon.svg",
      selectedUrl: "finance",
    },
    8955830: {
      fullName: "Governance & Resilience",
      collapsedName: "Govern...",
      url:"/subscription-portal/requests",
      lockIcon: "/images/msp/lock-icon.svg",
      menuIcon: "/images/navIcons/complianceDashboardIcon.svg",
      selectedUrl: "requests",
    },
    15576682: {
      fullName: "Security Stack Report",
      collapsedName: "Security Stack Report",
      url:"/subscription-portal/sec-stack-report",
      lockIcon: "/images/msp/lock-icon.svg",
      menuIcon: "/images/navIcons/security-stack-icon.svg",
      selectedUrl: "sec-stack-report",
    },
  };

  const mspDetail = window.localStorage.getItem("object_Data")
    ? JSON.parse(window.localStorage.getItem("object_Data"))?.mspDetail
      ? JSON.parse(window.localStorage.getItem("object_Data"))?.mspDetail
      : null
    : null;
    

  if (dbObj && dbObj.UserDetail) {
    return (
      <div
        className="fullHeight position-relative test"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        {modal}

        <div
          className="d-flex flex-column  img_wrapper"
        >
          <div className="d-flex w-100 align-items-center justify-content-between">
            <div className="d-flex align-items-center px-0 w-100" style={{ height: '44px' }}>
              <div 
                className={`h-100 justify-content-center align-items-center w-100 position-relative parent-visible ${!isMenuCollapse ? "d-none" : "d-flex"}`}
              >
                <img
                  alt=""
                  className={`logo`}
                  style={{ height: "25px", minHeight: "25px" }}
                  src="/images/logo/highground/short.svg"
                />
                {!isTablet && (
                    <div 
                      className="collapse-button-wrapper child-visible pointer"
                      onClick={handleCollapse}
                  >
                    <CollapseButton isMenuCollapse={isMenuCollapse} handleCollapse={handleCollapse} />
                  </div>
                )}
              </div>

              <img
                alt=""
                className={`logo ${isMenuCollapse ? "d-none" : ""}`}
                height={25}
                style={{ marginLeft: "4px" }}
                src="/images/msp/subscription-side-menu-logo.svg"
              />
            </div>
            {!isMenuCollapse && (
              <CollapseButton isMenuCollapse={isMenuCollapse} handleCollapse={handleCollapse} />
            )}
          </div>
          {/* Request demo div */}
          <div
            className={` radius-4  flex-column align-items-center ${
              showRequestDemo ? "d-flex small-request-demo" : "d-none"
            }`}
            style={{ background: "#EBF6FC" }}
            onClick={() => {
              let btn = document.querySelector(".calendly-button");
              btn.click();
            }}
          >
            <img
              src="/images/request-demo-collapse.svg"
              alt=""
              className="mb-2"
            />
            <div className="f-500 f-blue">Reque...</div>
          </div>
        </div>
        <div
          className="wrapper-container"
          style={{
            flexGrow: "500",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Col xs={12} className="px-0 linkMenu">
            {CURRENT_URL.includes("MSP") ? (
              <ul className="nav hide-scrollbar">
                {NAVIGATION_BUTTONS.map((element) => {
                  return (
                    <li>
                      <NavLink exact to={element.url} activeClassName="active">
                        <span>{element.image}</span>
                        <p>{element.text}</p>
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <>
                {MspUser == "true" && (
                  <div
                    className="crsrpoint"
                    onClick={() => {
                      updateuser();
                    }}
                  >
                    <div className="MSPButton">
                      <div id="branding">
                        {/* Add Inline Chevron and MSP Text */}
                        <span>{`<`}</span>
                        <p>MSP</p>
                      </div>
                      <div id="companyDetails" className="ml-3">
                        <h2>{USER_COMPANY}</h2>
                        <h3>Logged in as {USER_ROLE}</h3>
                        {/* Block elements - one header, one subheader */}
                      </div>
                    </div>
                  </div>
                )}

                <ul className="nav hide-scrollbar align-items-center">
                  {dbObj.MenuVisbility && dbObj.MenuVisbility.show_DashBoard ? (
                    <>
                      {!isMenuCollapse && (
                        <li
                          className={`demo-btn  ${
                            showRequestDemo ? "d-flex" : "d-none"
                          } `}
                        >
                          <Button
                            className="d-flex align-items-center justify-content-between request-demo"
                            onClick={() => {
                              TrackUser("Request Demo Clicked");
                              let btn =
                                document.querySelector(".calendly-button");
                              btn.click();
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <img
                                alt=""
                                src="/images/settings-v2/request-demo.svg"
                                className="mr-3"
                              />
                              <div className="d-flex align-items-center">
                                Request demo
                              </div>
                            </div>

                            <img
                              alt=""
                              src="/images/settings-v2/chevron-right-blue.svg"
                              className="chev"
                            />
                          </Button>
                        </li>
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {/* Attack Surface Menu option */}
                  {isNavLoading ? (
                    <div>
                      <SplitSectionTabLoader />
                    </div>
                  ) : (
                    navData?.map((menuItem, menuItemIndex) => {
                      if (!menuItem.showMenuItem) return null;
                      const isSelected = selectedUrl &&
                      selectedUrl?.url ===
                        SideBarData[menuItem?.MenuItemId]?.url;
                      return (
                        <OverlayTrigger
                          trigger={
                            menuItem?.disableState ? ["hover", "focus"] : []
                          }
                          key={menuItem?.MenuItemId}
                          placement={"right"}
                          overlay={
                            <Tooltip id={`tooltip-${menuItem?.MenuItemId}`}>
                              {menuItem?.hoverText}
                            </Tooltip>
                          }
                        >
                          <li
                            className={`
          ${
            URLpath[1] === SideBarData[menuItem?.MenuItemId]?.selectedUrl
              ? "active-tab"
              : ""
          }
          ${
            URLpath[2] === SideBarData[menuItem?.MenuItemId]?.selectedUrl
              ? "active-tab"
              : ""
          }
          ${menuItem?.showMenuItem ? "" : "d-none"}
          ${menuItem?.disableState ? "disabled-main-dashboard-menuItem" : ""}
        `}
                            onClick={() => {
                              if (menuItem?.disableState) return;
                              if (menuItem?.MenuItemId === 5062724) {
                                return;
                              }
  
                              TrackUser(
                                SideBarData[menuItem?.MenuItemId]?.fullName +
                                  " opened"
                              );
                              localStorage.setItem("redirectTab", false);
                              localStorage.setItem(
                                "currentUrl",
                                JSON.stringify({
                                  url: SideBarData[menuItem?.MenuItemId]?.url,
                                  name: SideBarData[menuItem?.MenuItemId]
                                    .fullName,
                                })
                              );
                              navigate(
                                SideBarData[menuItem?.MenuItemId]?.url
                              ); // Use navigate to navigate
                            }}
                          >
                            <Link
                              onClick={(e) => {
                                if (menuItem?.disableState) {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }
                              }}
                              to={
                                menuItem?.disableState
                                  ? ""
                                  : SideBarData[menuItem?.MenuItemId]?.url
                              }
                              className={`menumanagesecurity d-flex align-items-center ${
                                isSelected
                                  ? "active"
                                  : ""
                              } ${isMenuCollapse ? 'justify-content-center' : ''}`}
                            >
                              <span className="menu-icon">
                                <img
                                  alt=""
                                  src={
                                    menuItem?.disableState
                                      ? SideBarData[menuItem?.MenuItemId]
                                          ?.lockIcon
                                      : SideBarData[menuItem?.MenuItemId]
                                          ?.menuIcon
                                  }
                                ></img>
                              </span>
  
                              <p className={`managedSecurityMenu mb-0 ${isSelected ? 'active' : ''} ${isMenuCollapse ? 'd-none' : ''}`}>
                                <span className="mb-0">
                                  {!isMenuCollapse
                                    ? menuItem?.ExpandedText
                                    : menuItem?.CollapsedText}
                                </span>
                              </p>
                              {menuItem?.recordCount && (
                                <span 
                                  className={`flex-1 pr-3 record-count ${isMenuCollapse ? 'd-none' : ''}`} 
                                  style={{ 
                                    textAlign:'end',
                                    ...(menuItem.recordBackColor && { backgroundColor: menuItem.recordBackColor, color: '#fff' }),
                                  }}
                                >
                                  {menuItem?.recordCount}
                                </span>
                              )}
                              {menuItem?.DevStatus !== "Live" &&
                                menuItem?.disableState === false && (
                                  <span className="beta-tag">
                                    {menuItem?.DevStatus}
                                  </span>
                                )}
                            </Link>
                          </li>
                        </OverlayTrigger>
                      );
                    })
                  )}
                </ul>
              </>
            )}
            <div
              className="test-blur"
              style={{
                width: "100%",
                background: "white",
                height: "24px",
                filter: "blur(6px)",
                zIndex: -1,
                position: "absolute",
                top: "80%",
                display: "none",
              }}
            ></div>
          </Col>
          <div
            className="absoulteBottom"
            style={{
              position: `${isMenuCollapse ? "absolute" : "absolute"}`,
              zIndex: 0,
            }}
          >
            {!isMenuCollapse && !CURRENT_URL.includes("MSP") && (
              <>
                {mspDetail ? (
                  <Row>
                    <Col className="upgradePro border-none-imp">
                      <div className="d-flex align-items-center position-relative parent-visible">
                        <div
                          className="position-absolute radius-4 child-visible"
                          style={{
                            zIndex: 5,
                            background: "#fff",
                            boxShadow: "2px 2px 10px -3px rgba(0,0,0,0.75)",
                            width: "237px",
                            left: "-20px",
                          }}
                        >
                          <div className="d-flex align-items-center border-bottom px-2 py-3">
                            <div className="position-relative mr-3">
                              <img
                                alt=""
                                src={mspDetail?.logo}
                                className=" rounded-full"
                                width={24}
                                height={24}
                              />
                              <img
                                alt=""
                                src="/images/settings-v2/settingwheel.svg"
                                width={13}
                                height={13}
                                className="position-absolute "
                                style={{
                                  top: "95%",
                                  transform: "translate(-67%, -50%)",
                                  zIndex: 2,
                                }}
                              />
                            </div>
                            <div className="f-600">
                              {TrimString(mspDetail?.name, 20)}
                            </div>
                          </div>
                          <div className=" f-12 f-500 f-darkgrey pl-2 pt-1">
                            {" "}
                            Contact details
                          </div>
                          <div className="f-12 px-2">
                            <div className="d-flex mb-2">
                              <div className="w-20 f-grey">Email</div>
                              <div className="w-80">
                                {TrimString(mspDetail?.email, 25)}
                              </div>
                            </div>
                            <div className="d-flex mb-2">
                              <div className="w-20 f-grey">Phone</div>
                              <div className="w-80">
                                {" "}
                                {TrimString(mspDetail?.phoneNumber, 25)}{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="position-relative mr-3">
                          <img
                            alt=""
                            src={mspDetail?.logo}
                            className=" rounded-full"
                            width={24}
                            height={24}
                          />
                          <img
                            alt=""
                            src="/images/settings-v2/settingwheel.svg"
                            width={13}
                            height={13}
                            className="position-absolute "
                            style={{
                              top: "95%",
                              transform: "translate(-67%, -50%)",
                              zIndex: 2,
                            }}
                          />
                        </div>
                        <div>
                          <div className="f-12 f-darkgrey">Managed by</div>
                          <div className="f-500 f-black">
                            {" "}
                            {TrimString(mspDetail?.name, 20)}{" "}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <>
                    {upgradePopupData && false ? (
                      <Row>
                        {isUpgradeProCollapse ? (
                          <Col className="upgradePro">
                            <div className="d-flex justify-content-between">
                              <div
                                className="text-center"
                                onClick={() =>
                                  TrackUser("Upgrade Now button clicked")
                                }
                              >
                                <Link
                                  to={upgradePopupData?.SubmitButton?.ButtonUrl}
                                  className="pl-4 ml-1 urgradeTextSidebar new-upgrade"
                                >
                                  <span className="pl-4">
                                    <img
                                      alt=""
                                      src={
                                        upgradePopupData?.SubmitButton
                                          ?.ButtonImage
                                      }
                                      height="20"
                                      className="mr-2"
                                    />
                                  </span>
                                  {upgradePopupData?.SubmitButton?.ButtonText}
                                </Link>
                              </div>
                              <div>
                                <img
                                  alt=""
                                  src="/images/dashboard/upgradeCollapse.svg"
                                  onClick={() => setIsUpgradeProCollapse(false)}
                                />
                              </div>
                            </div>
                          </Col>
                        ) : (
                          <Col className="upgradePro mt-4">
                            <div className="d-flex justify-content-between">
                              {isUpgradeProCollapse ? (
                                <div className="mt16px mb-2 text-center">
                                  <img alt="" src="/images/upgradeBell.svg" />
                                  <Link
                                    // to="/system_settings?tab=subscriptions"
                                    to="/settings/v2/subscriptions"
                                  >
                                    <img
                                      alt=""
                                      src="/images/upgradeNow.svg"
                                      className="upgradeText"
                                    />
                                  </Link>
                                </div>
                              ) : (
                                <div
                                  className="w-fit-content pointer p-1"
                                  onClick={(event) => {
                                    TrackUser("Upgrade button clicked off");
                                    upgradeProHandler(event);
                                  }}
                                >
                                  <img
                                    alt=""
                                    src="/images/attack-surface/chevron-down.svg"
                                    className="closeButton"
                                    onClick={(event) => {
                                      TrackUser("Upgrade button clicked off");
                                      upgradeProHandler(event);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                            <div>
                              <div className="text-center">
                                <img
                                  alt=""
                                  width={25}
                                  src={upgradePopupData?.LogoImageUrl}
                                  className=""
                                />
                              </div>

                              <p className="text-center my-1 upgrade_pro_title">
                                {upgradePopupData?.Title}
                              </p>
                              {upgradePopupData?.SubTitle && (
                                <div className="f-12 f-500 text-center f-grey">
                                  {upgradePopupData?.SubTitle}
                                </div>
                              )}
                              {upgradePopupData?.FeatureHeader && (
                                <div className="f-12 f-400  ">
                                  {upgradePopupData?.FeatureHeader}
                                </div>
                              )}

                              {upgradePopupData?.Features?.map((_data) => {
                                return (
                                  <div className="d-flex align-self-center mt-2">
                                    <img
                                      width={12}
                                      height={12}
                                      alt=""
                                      src={_data?.IconUrl}
                                    />
                                    <span
                                      className="linkGreyText"
                                      style={{ paddingLeft: "5px" }}
                                    >
                                      {_data?.Feature}
                                    </span>
                                  </div>
                                );
                              })}

                              {upgradePopupData?.FeatureFooter && (
                                <div className="f-12 f-400  mt-2">
                                  {upgradePopupData?.FeatureFooter}
                                </div>
                              )}

                              <div
                                className="mt16px mb-2 text-center"
                                onClick={() =>
                                  TrackUser("Upgrade Now button clicked")
                                }
                              >
                                {/* <img src="/images/upgradeBell.svg" /> */}
                                <Link
                                  // to="/system_settings?tab=subscriptions"
                                  to={upgradePopupData?.SubmitButton?.ButtonUrl}
                                  className="urgradeTextSidebar"
                                >
                                  <img
                                    alt=""
                                    src={
                                      upgradePopupData?.SubmitButton
                                        ?.ButtonImage
                                    }
                                    className="mr-2"
                                    width={20}
                                    height={20}
                                  />

                                  {upgradePopupData?.SubmitButton?.ButtonText}
                                </Link>
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    ) : (
                      ""
                    )}
                  </>
                )}

                 
              </>
            )}

           

             
          </div>
        </div>
        {/* Load static image onload managesecutiry  */}
        <img src="/images/coimgsoon.svg" className="d-none" alt="" />
      </div>
    );
  } else {
    return "";
  }
};

// const mapStateToProps = createStructuredSelector({
//   isMenuCollapse: getMenuCollapseStatus(),
//   user: getUser(),
// });

// const compose = connect(mapStateToProps, { menuToggle, setuser });

// export default compose(SideNav);
export default SideNav;
